<template>
  <div class="quick-wrap" v-show="show" @touchmove.prevent>
    <div class="quick-order">
      <div class="head-wrap">
        <div class="alert">Message Alert</div>
        <div class="icon-close" @click="close">
          <span class="iconfont icon1">&#xe614;</span>
          <span class="iconfont icon2">&#xe606;</span>
        </div>
      </div>
      <div class="content-wrap">
        <div class="remark">Some products cannot proceed with opportunity review due to invalid product codes. Please verify the product codes. Contact your assigned sales representative if needed.</div>
        <ul class="fail-list">
          <li class="fail-item" v-for="item,i in failList" :key="i">
            <span class="product-name" v-if="item.productName">{{ item.productName }}</span>
            <span class="meta-item" v-if="item.model"><span class="label">Model:</span><span class="value">{{ item.model }}</span></span>
            <span class="meta-item" v-if="item.ean"><span class="label">EAN10:</span><span class="value ean">{{ item.ean }}</span></span>
          </li>
        </ul>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name:'ReleaseError',
  data() {
    return {
      failList:[], //失败的EAN的列表
      show:false
    }
  },
  methods:{
    open(failList){
      this.failList=failList || []
      this.show=true
    },
    close(){
      this.show=false
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../../../public/css/public.less');
/* 快速下单 */
.quick-wrap{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  overflow: hidden;
  .quick-order{
    border-radius: 4px;
    position: absolute;
    // &:extend(.main-box-shadow);
    width:800px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    // padding:40px;
    box-sizing: border-box;
    text-align: left;
    .head-wrap{
      display: flex;
      justify-content: space-between;
      position: relative;
      padding:16px;
      border-bottom: 1px solid @darkBorderColor;
      .alert{
        color:@mainColor;
        font-weight:600;
        font-size: 17px;
      }
      .icon-close{
      .icon1{
        font-size: 24px;
        display: block;
        color:#888;
      }
      .icon2{
        font-size: 24px;
        display: none;
        color:@mainColor;
      }
      &:hover{
        cursor: pointer;
        .icon1{
          display: none;
        }
        .icon2{
          display: block;
        }
      }
    }
    }
    .content-wrap{
      padding:0px 40px 30px;
      .remark{
        text-align: left;
        margin-top: 16px;
        font-weight: 600;
      }
      /* 失败产品列表：每项一张浅色卡片，productName 主标题 + Model/EAN10 带标签分行，无效编码 EAN10 红色高亮 */
      .fail-list{
        margin: 12px 0 0;
        padding: 0;
        list-style: none;
        max-height: 320px; /* 失败项过多时列表内部滚动，不撑爆弹窗 */
        overflow-y: auto;
        .fail-item{
          display: flex;
          align-items: center;
          flex-wrap: wrap; /* 一行排不下时自动换行，不溢出 */
          padding: 8px 12px;
          border: 1px solid @darkBorderColor;
          border-radius: 4px;
          background-color: @darkBgcColor;
          & + .fail-item{
            margin-top: 8px;
          }
          .product-name{
            width:270px;
            font-size: 13px;
            font-weight: 600;
            color: @mainFontColor;
            line-height: 20px;
            margin-right: 10px;
            word-break: break-word;
            // background-color: red;
          }
          .meta-item{
            // background-color: red;
            font-size: 12px;
            line-height: 20px;
            &:not(:last-child){
              margin-right: 10px;
            }
            .label{
              color: @inpNumColor;
              margin-right: 4px;
              display: inline-block
            }
            .value{
              color: @mainFontColor;
              font-weight: 500;
              width:210px;
              display: inline-block
            }
            .ean{
              color: @dangerColor;
              font-weight: 600;
              width:100px;
              display: inline-block
            }
          }
        }
      }
    }
    
  }
}

</style>